import { useState, useEffect } from "react";
import Api from "../../../../../Api/Api";

// Interface para dados retornados pela API
export interface DadosPreenchimento {
  // Dados básicos
  cliente?: {
    nome?: string;
    telefone?: string;
    email?: string;
    cpf_cnpj?: string;
    dataNascimento?: string;
    enderecocliente?: {
      cep?: string;
      endereco?: string;
      numero?: string;
      bairro?: string;
      cidade?: {
        id: string;
      };
      estado?: {
        id: string;
      };
    };
  };
  status?: string;
  formaPagamento?: string;
  statusUltimaFatura?: string;
}

interface UsePreencherDadosReturn {
  isLoading: boolean;
  error: string | null;
  dados: DadosPreenchimento | null;
  buscarDados: (hash: string) => Promise<void>;
  limparErro: () => void;
}

export const usePreencherDados = (): UsePreencherDadosReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [dados, setDados] = useState<DadosPreenchimento | null>(null);

  const buscarDados = async (hash: string): Promise<void> => {
    if (!hash.trim()) {
      setError("Hash é obrigatório");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const resultado = await Api.preencherPagamento(hash);
      // --TODO: REMOVER O CONSOLE.LOG APÓS TESTES

      if (resultado.status && resultado.data) {
        setDados(resultado.data);
      } else {
        setError(resultado?.error_details?.message || "Erro ao buscar dados");
      }
    } catch (err) {
      console.log("err ", err);
      setError("Erro inesperado ao buscar dados");
    } finally {
      setIsLoading(false);
    }
  };

  const limparErro = () => {
    setError(null);
  };

  return {
    isLoading,
    error,
    dados,
    buscarDados,
    limparErro,
  };
};
